// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5743c99d","703":"61472410","787":"66e684a5"}[chunkId] + ".chunk.js";
};